export default function Marquee() {
  const items = [
    "BILLETTERIE OFFICIELLE",
    "PAIEMENT SÉCURISÉ STRIPE",
    "E-TICKETS INSTANTANÉS",
    "PARIS LA DÉFENSE ARENA",
    "ACCOR ARENA BERCY",
    "16 DATES CÉLINE DION",
  ];
  const repeated = [...items, ...items, ...items, ...items];
  return (
    <div className="marquee" data-testid="trust-marquee">
      <div className="marquee-track">
        {repeated.map((t, i) => (
          <span key={i} className="font-mono text-xs tracking-[0.25em] text-muted-foreground inline-flex items-center gap-12">
            <span className="text-primary">◆</span> {t}
          </span>
        ))}
      </div>
    </div>
  );
}
